import { Storage } from '@ionic/storage';
import { AccessmanagementApi } from '../../shared/sdk/services/custom/Accessmanagement';
import { AuthApi } from '../../shared/nestjs/gd-only/services/auth.api';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class SetDeviceBloc {

    constructor(
        private nestApiProvider: NestApiProvider,
        private authApi: AuthApi,
        private accessmanagementApi: AccessmanagementApi,
        private storage: Storage
    ) {

    }

    loadAuth(): Promise<any> {
        return new Promise(async (resolve) => {
            try {
                await this.storage.ready();
                const data = JSON.parse(await this.storage.get('SFGoAuth'));
                resolve(data);
            } catch (error) {
                resolve(false);
            }
        })
    }

    setDevice(pin: any): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.authApi.setDevicePIN(pin)
                        .pipe(
                            map(param => param.data)
                        )
                } else {
                    return this.accessmanagementApi.setPIN(pin)
                        .pipe(
                            map(param => param.result.newpin)
                        )
                }
            })
    }

    updateStorage(resPin: any): Promise<any> {
        return new Promise(async (resolve) => {
            try {
                let SFGoStorage = await this.storage.get('SFGoStorage');
                if (SFGoStorage == null) {
                    SFGoStorage = {}
                } else {
                    SFGoStorage = JSON.parse(SFGoStorage);
                }
                SFGoStorage.storedPIN = resPin;
                this.storage.set('SFGoStorage', JSON.stringify(SFGoStorage));
                resolve();
            } catch (error) {
                resolve();
            }
        })
    }


}



// WEBPACK FOOTER //
// ./src/bloc/settings/set-device.bloc.ts